import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { GetSkAdNetworkApplicationStatusResponseActionPayload } from '../SKANPostbacksConversionMapping.types';

const GetSkAdNetworkApplicationStatus = new ReduxAsyncAction<
  'GET_SK_AD_NETWORK_APPLICATION_STATUS',
  void,
  GetSkAdNetworkApplicationStatusResponseActionPayload
>('GET_SK_AD_NETWORK_APPLICATION_STATUS');

GetSkAdNetworkApplicationStatus.registerRequest(async () => {
  try {
    const response = await dash_api.get<GetSkAdNetworkApplicationStatusResponseActionPayload>(
      '/v1/skadnetworkv2/skan-app-status'
    );

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get Sk Ad Network Application status. Please try again.', 'error');

    throw error;
  }
});

export const GET_SK_AD_NETWORK_APPLICATION_STATUS = GetSkAdNetworkApplicationStatus.actionNamespaceConstants;

export const getSkAdNetworkApplicationStatus = GetSkAdNetworkApplicationStatus.request;

export type GetSkAdNetworkApplicationStatusResponseAction = Action<typeof GET_SK_AD_NETWORK_APPLICATION_STATUS.response> & {
  data: GetSkAdNetworkApplicationStatusResponseActionPayload;
};
